import { render, staticRenderFns } from "./TableCreated.vue?vue&type=template&id=61221ec3&scoped=true"
import script from "./TableCreated.vue?vue&type=script&lang=js"
export * from "./TableCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61221ec3",
  null
  
)

export default component.exports